<template>
  <div class="error-block" v-if="errors">
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="danger"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      v-for="error in errors"
    >
      <b-progress
        variant="warning"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      ></b-progress>
      {{error.toString()}}
    </b-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 10,
      showDismissibleAlert: false
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  },
  computed: {
    errors () {
      return this.$store.state &&  this.$store.state.errors && this.$store.state.errors.errors;
    },
  }
};
</script>

<style>
.error-block {
  position: fixed;
  right: 20px;
  bottom: 20px;
  color: #856404;
  border-radius: .25rem;
  padding: .75rem 1.25rem;
  animation-name: example;
  animation-duration: 1s;
}

@keyframes example {
  0%   {
    right: 2000px;
  }
  100% {
    right: 20px;
  }
}

</style>

